import * as React from "react";
const SvgCheckmark = (props) => /* @__PURE__ */ React.createElement("svg", { className: "svg-icon", focusable: "false", viewBox: "0 0 24 24", ...props }, /* @__PURE__ */ React.createElement("path", { fillRule: "evenodd", d: "M16.6 7.5 18 9l-7.4 7.5L6 11.9l1.4-1.5 3.2 3.2 6-6.1z", clipRule: "evenodd" }));
export default SvgCheckmark;
